<template>
  <div class="title" v-bind:class="{more: more}" :style="h_padding">
    <h3 class="font_normal font_16_black" v-bind:style="{fontSize: this.font + 'px'}">{{title}}</h3>
    <span v-if="more">
      <router-link :to="to">
      <img src="@/assets/icons/more@2x.png" alt />
      </router-link>
    </span>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: String,
    path: String,
    padding: String,
    paddingLeft: String,
    paddingRight: String,
    font: String,
    more: Boolean
  },
  data() {
    return {
      to: this.path || "/",
      h_padding: {
        paddingLeft: (this.padding || this.paddingLeft || 0) + "px",
        paddingRight: (this.padding || this.paddingRight || 0) + "px"
      }
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  width: 100%;
  height: 58px;
  // padding: 0 36px;
  &.more {
    justify-content: space-between;
  }
  h3 {
    margin: 0;
  }
  span {
    width: 24px;
    height: 24px;
    a {
      display: block;
      height: 100%;
    }
    img {
      width: 100%;
    }
  }
}
</style>